import { useState, useEffect } from "react";

export default function Diagnostic() {
  const [info, setInfo] = useState({ loading: true });
  const [seedResult, setSeedResult] = useState(null);
  const [seeding, setSeeding] = useState(false);

  const API = process.env.REACT_APP_BACKEND_URL + "/api";

  useEffect(() => {
    const check = async () => {
      const result = {
        loading: false,
        env_url: process.env.REACT_APP_BACKEND_URL || "NOT SET",
        api_url: API,
        timestamp: new Date().toISOString(),
      };

      try {
        const statusRes = await fetch(`${API}/seed/status`);
        result.seed_status = await statusRes.json();
        result.backend_reachable = true;
      } catch (e) {
        result.backend_reachable = false;
        result.backend_error = e.message;
      }

      try {
        const statsRes = await fetch(`${API}/stats`);
        result.stats = await statsRes.json();
      } catch (e) {
        result.stats_error = e.message;
      }

      try {
        const seriesRes = await fetch(`${API}/series`);
        result.series = await seriesRes.json();
        result.series_count = Array.isArray(result.series) ? result.series.length : "not an array";
      } catch (e) {
        result.series_error = e.message;
      }

      setInfo(result);
    };
    check();
  }, [API]);

  const triggerSeed = async () => {
    setSeeding(true);
    try {
      const res = await fetch(`${API}/seed`, { method: "POST" });
      const data = await res.json();
      setSeedResult(data);
    } catch (e) {
      setSeedResult({ error: e.message });
    }
    setSeeding(false);
  };

  const triggerForceSeed = async () => {
    setSeeding(true);
    try {
      const res = await fetch(`${API}/seed/force`, { method: "POST" });
      const data = await res.json();
      setSeedResult(data);
    } catch (e) {
      setSeedResult({ error: e.message });
    }
    setSeeding(false);
  };

  if (info.loading) {
    return <div style={{ padding: 40, color: "#fff", background: "#111", minHeight: "100vh", fontFamily: "monospace" }}>Loading diagnostics...</div>;
  }

  return (
    <div style={{ padding: 40, color: "#fff", background: "#111", minHeight: "100vh", fontFamily: "monospace", fontSize: 14 }}>
      <h1 style={{ color: "#e33", fontSize: 24, marginBottom: 20 }}>Red Ink Studios — Diagnostic</h1>

      <section style={{ marginBottom: 20 }}>
        <h2 style={{ color: "#f99", fontSize: 16 }}>Environment</h2>
        <pre style={{ background: "#222", padding: 12, borderRadius: 6, overflow: "auto" }}>
          REACT_APP_BACKEND_URL: {info.env_url}{"\n"}
          API endpoint: {info.api_url}{"\n"}
          Backend reachable: {info.backend_reachable ? "YES" : "NO"}{"\n"}
          {info.backend_error && `Backend error: ${info.backend_error}\n`}
          Timestamp: {info.timestamp}
        </pre>
      </section>

      {info.seed_status && (
        <section style={{ marginBottom: 20 }}>
          <h2 style={{ color: "#f99", fontSize: 16 }}>Database Status</h2>
          <pre style={{ background: "#222", padding: 12, borderRadius: 6, overflow: "auto" }}>
{JSON.stringify(info.seed_status, null, 2)}
          </pre>
        </section>
      )}

      {info.stats && (
        <section style={{ marginBottom: 20 }}>
          <h2 style={{ color: "#f99", fontSize: 16 }}>Stats</h2>
          <pre style={{ background: "#222", padding: 12, borderRadius: 6, overflow: "auto" }}>
{JSON.stringify(info.stats, null, 2)}
          </pre>
        </section>
      )}

      <section style={{ marginBottom: 20 }}>
        <h2 style={{ color: "#f99", fontSize: 16 }}>Series Count: {info.series_count ?? "error"}</h2>
        {info.series_error && <p style={{ color: "#f66" }}>Error: {info.series_error}</p>}
      </section>

      <section style={{ marginBottom: 20 }}>
        <h2 style={{ color: "#f99", fontSize: 16 }}>Manual Seed Controls</h2>
        <button
          onClick={triggerSeed}
          disabled={seeding}
          style={{ padding: "10px 24px", background: "#c33", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", marginRight: 12, opacity: seeding ? 0.5 : 1 }}
        >
          {seeding ? "Seeding..." : "Seed Database"}
        </button>
        <button
          onClick={triggerForceSeed}
          disabled={seeding}
          style={{ padding: "10px 24px", background: "#666", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", opacity: seeding ? 0.5 : 1 }}
        >
          Force Re-seed
        </button>
        {seedResult && (
          <pre style={{ background: "#222", padding: 12, borderRadius: 6, overflow: "auto", marginTop: 12 }}>
{JSON.stringify(seedResult, null, 2)}
          </pre>
        )}
      </section>

      <section>
        <h2 style={{ color: "#f99", fontSize: 16 }}>Quick Links</h2>
        <ul style={{ listStyle: "none", padding: 0 }}>
          <li><a href={`${info.api_url}/seed/status`} target="_blank" rel="noreferrer" style={{ color: "#6cf" }}>Raw: /api/seed/status</a></li>
          <li><a href={`${info.api_url}/seed`} target="_blank" rel="noreferrer" style={{ color: "#6cf" }}>Raw: /api/seed (triggers seed)</a></li>
          <li><a href={`${info.api_url}/stats`} target="_blank" rel="noreferrer" style={{ color: "#6cf" }}>Raw: /api/stats</a></li>
          <li><a href={`${info.api_url}/series`} target="_blank" rel="noreferrer" style={{ color: "#6cf" }}>Raw: /api/series</a></li>
          <li><a href="/" style={{ color: "#6cf" }}>Back to Home</a></li>
        </ul>
      </section>
    </div>
  );
}
